<main id="otp" class="w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <h2 class="text-center">Authentication error</h2>
    </div>
    <div class="notice error text-sm mt-8 mb-8 text-center">
      <p>{{ 'OTP.IFRAME_TOKEN_MISSING' | translate }}</p>
    </div>
    <div class="row mt-2">
      <div class="btn-wr mb-2">
        <button class="btn primary-btn w-full" (click)="backToEmbeddedRoute()">Restart frame</button>
      </div>
    </div>
  </div>
</main>
